import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Page from '../../components/Page';
import RoutesUtils from '../../utils/routes';

const mapStateToProps = (state: StoreState) => {
	const { search, routerParamsHistory } = state;
	const origin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
	const originParam = RoutesUtils.getCurrentOriginParam(routerParamsHistory);
	return { showSearchField: search.isShown, origin, originParam };
};

export default connect(mapStateToProps)(Page);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Page/index.tsx